





























import {Component, Prop, Vue, Watch} from 'vue-property-decorator';
import ECharts from 'vue-echarts'
import Util from '../../../lib/util'
import {GetAntiMedicineList,GetConsByType} from '../../../api/configureDictionary'

@Component({
    components:{}
})
export default class  extends Vue {
    @Prop({type:Object,default:{}}) data:any;

    @Watch('checkData')
    WatchcheckCountString(val:any){
        this.checkCountString = `已选择 ${val.length}`
        this.$emit('on-back',this.checkData)
    }
    modalShow:boolean = true
    tabsName = '标签一'
    tabsData:any = []
    //选择后右侧带出
    checkData:any = []

    checkCountString = '已选择 0'
    //获取耗材列表
    async getConsByType(){
        let res = await GetConsByType()
        this.tabsData = res
    }
    checkChange(item:any,conType:any){
        if(item.check){
            this.checkData.push({
                consumableId:item.consumableId,
                conName:item.conName,
                quantity:1,
                conType:conType,
                unit:item.unit
            })
        }else{
            this.checkData.forEach((v:any,index:any)=>{
                if(v.consumableId == item.consumableId){
                    this.checkData.splice(index,1)
                }
            })
        }
    }
    //删除所有
    removeAll(){
        this.tabsData.forEach((item:any)=>{
            if(item.items){
                item.items.forEach((v:any)=>{
                    v.check = false
                    this.checkChange(v,'')
                })
            }
        })
    }
    //单个删除
    remove(row:any){
        this.tabsData.forEach((item:any)=>{
            if(item.items){
                item.items.forEach((v:any)=>{
                    if(row.consumableId == v.consumableId){
                        v.check = false
                        this.checkChange(v,'')
                    }
                })
            }
        })
    }


    async created() {
        await this.getConsByType()
        console.log(1,this.data.list)
        this.checkData = this.data.list
        this.tabsData.forEach((v:any)=>{
            if(v.items){
                v.items.forEach((h:any)=>{
                    this.data.list.forEach((item:any,index:any)=>{
                        if(item.consumableId == h.consumableId){
                            h.check = true
                        }
                    })
                })
            }
        })
    }
    mounted() {
        this.$nextTick(()=>{
            let dom:any = document.getElementById('rightTabs').getElementsByClassName('ivu-tabs-ink-bar')[0];
            dom.style.backgroundColor = 'transparent'
        })
    }
}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/views/dialysisProcess/waitRoom/conEdit.vue